import { useEffect } from 'react';
import { SocialButton, SocialRow } from '@src/components/SocialButton/SocialButton';
import { showToast } from '@src/components/Toast';
import { isDotCom } from '@src/site';
import { loadTelegramWidget } from '@src/utils/telegramWidget';

export interface AuthSocialLabels {
  google: string;
  telegram: string;
  vk: string;
}

export interface AuthSocialProps {
  labels: AuthSocialLabels;
  disabled?: boolean;
  /** Toast when a disabled social button is clicked. */
  disabledHint?: string;
  testId?: string;
  onGoogle: () => void;
  onTelegram: () => void;
  onVk: () => void;
}

/** Google + Telegram on .com, VK on .ru — same split as v1. */
export function AuthSocial({
  labels,
  disabled,
  disabledHint,
  testId,
  onGoogle,
  onTelegram,
  onVk,
}: AuthSocialProps) {
  const com = isDotCom();

  function activate(handler: () => void) {
    if (disabled && disabledHint) {
      showToast(disabledHint);
      return;
    }
    handler();
  }

  useEffect(() => {
    if (com) {
      loadTelegramWidget().catch(() => undefined);
    }
  }, [com]);

  if (com) {
    return (
      <SocialRow columns={2} testId={testId}>
        <SocialButton
          kind="google"
          disabled={disabled}
          disabledHint={disabledHint}
          testId={testId && `${testId}-google`}
          onClick={() => activate(onGoogle)}
        >
          {labels.google}
        </SocialButton>
        <SocialButton
          kind="telegram"
          disabled={disabled}
          disabledHint={disabledHint}
          testId={testId && `${testId}-telegram`}
          onClick={() => activate(onTelegram)}
        >
          {labels.telegram}
        </SocialButton>
      </SocialRow>
    );
  }

  return (
    <SocialRow columns={1} testId={testId}>
      <SocialButton
        kind="vk"
        disabled={disabled}
        disabledHint={disabledHint}
        testId={testId && `${testId}-vk`}
        onClick={() => activate(onVk)}
      >
        {labels.vk}
      </SocialButton>
    </SocialRow>
  );
}
